import React, { Component } from "react";

class WorkflowCompatibility extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        {" "}
        <h3>Compatibility</h3>
        <table style={{ width: "auto" }}>
          <tbody>
            <tr>
              <td className="b top">System</td>
              <td className="b top">Support</td>
            </tr>
            <tr>
              <td className="b" style={{ paddingTop: 4 }}>
                Front-end (Application)
              </td>
              <td style={{ textAlign: "center" }}>
                {this.props.front === true ? (
                  <i
                    className="material-icons"
                    style={{
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#388E3C",
                      fontWeight: "bold"
                    }}
                  >
                    done
                  </i>
                ) : (
                  <i
                    className="material-icons"
                    style={{
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#D32F2F",
                      fontWeight: "bold"
                    }}
                  >
                    close
                  </i>
                )}
              </td>
            </tr>
            <tr>
              <td className="b" style={{ paddingTop: 4 }}>
                Back-end (Workflow Engine)
              </td>
              <td style={{ textAlign: "center" }}>
                {this.props.back === true ? (
                  <i
                    className="material-icons"
                    style={{
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#388E3C",
                      fontWeight: "bold"
                    }}
                  >
                    done
                  </i>
                ) : (
                  <i
                    className="material-icons"
                    style={{
                      position: "relative",
                      top: 3,
                      fontSize: 24,
                      color: "#D32F2F",
                      fontWeight: "bold"
                    }}
                  >
                    close
                  </i>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default WorkflowCompatibility;



// WEBPACK FOOTER //
// ./src/components/Workflow/WorkflowCompatibility.js